module.exports = __webpack_public_path__ + "img/logo.8687ed29.png";